import React from "react";
import { Flex, Typography } from "antd";
import { ApartmentOutlined, SbTag } from "uiCore";
import SbCard from "uiCore/SbCard/SbCard";

import FunctionRow from "./FunctionRow";
import OptionAddInput from "./OptionAddInput";
import { BuIconStyled } from "./LegalEntityManagement.styles";

const { Text } = Typography;

const BusinessUnitSection = ({
  bu,
  fnOptions = [],
  subFnOptions = [],
  onAddFunction,
  onAddSubFunction,
}) => {
  const existingFnNames = (bu.functions || []).map((f) => f.function);

  return (
    <SbCard size="small" hoverable>
      <Flex align="center" gap={8}>
        <BuIconStyled>
          <ApartmentOutlined />
        </BuIconStyled>
        <Text strong>{bu.business_unit}</Text>
        <SbTag>{bu.functions?.length || 0}</SbTag>
      </Flex>

      {(bu.functions || []).map((fn, fnIdx) => (
        <FunctionRow
          key={`${fn.function}-${fnIdx}`}
          fn={fn}
          isFirst={fnIdx === 0}
          subFnOptions={subFnOptions}
          onAddSubFunction={(name) => onAddSubFunction(fnIdx, name)}
        />
      ))}

      <OptionAddInput
        placeholder="Add function"
        existingValues={existingFnNames}
        options={fnOptions}
        onAdd={onAddFunction}
      />
    </SbCard>
  );
};

export default BusinessUnitSection;
